import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/motion';
type LayerSectionProps = {
  id: string;
  number: number;
  level: string;
  title: string;
  tone?: 'white' | 'muted';
  intro?: React.ReactNode;
  children?: React.ReactNode;
};

/** One architecture layer, numbered to match the overview stack. */
export function LayerSection({
  id,
  number,
  level,
  title,
  tone = 'white',
  intro,
  children
}: LayerSectionProps) {
  return <section id={id} aria-labelledby={`${id}-title`} className={`scroll-mt-20 border-b border-line py-20 lg:py-24 ${tone === 'muted' ? 'bg-surface-bg' : 'bg-white'}`} data-id="element-1227" data-mp="t16it2fshe72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1228" data-mp="j9jxuedng0r4">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16" data-id="element-1229" data-mp="eaz0qntp1x6w">
          <div className="lg:col-span-5" data-id="element-1230" data-mp="9bcmqc61kcx1">
            <p className="flex items-center gap-3 text-sm font-medium text-teal mb-4" data-id="element-1231" data-mp="9abcg9wunugd">
              <span aria-hidden="true" className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-teal/60 text-sm font-semibold" data-id="element-1232" data-mp="5a110hqagbu4">
                {number}
              </span>
              {level}
            </p>
            <h2 id={`${id}-title`} className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-1233" data-mp="3e75whsi8aqh9">
              {title}
            </h2>
          </div>
          {intro && <div className="lg:col-span-7 lg:pt-11" data-id="element-1234" data-mp="apdurmeais5v">{intro}</div>}
        </motion.div>
        {children && <div className="mt-12" data-id="element-1235" data-mp="fnfem9jjivie">{children}</div>}
      </div>
    </section>;
}